import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type {
	AiSuggestionsPlugin,
} from '../aiSuggestionsPluginType';

import type { HideSuggestionDiffAction } from './types';

export const hideSuggestionDiffAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => HideSuggestionDiffAction = (api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(): boolean => {
		api?.core?.actions.execute(({ tr }) => {
			api?.showDiff?.commands.hideDiff?.({ tr });
			return tr;
		});
		return true;
	};
